import { AfterContentInit, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FuseTranslationLoaderService, Locale } from '@fuse/services/translation-loader.service';
import {locale as en} from './i18n/en';
import {locale as vn} from './i18n/vn';
@Component({
  selector: 'app-timepicker',
  templateUrl: './timepicker.component.html',
  styleUrls: ['./timepicker.component.scss']
})
export class TimepickerComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<void>();
  @ViewChild('divHours') divHours:any; 
  @ViewChild('divMinutes') divMinutes:any; 
  el: any
  hour: any
  minute: any
  hours: any
  minutes: any
  constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService) { 
    this.minutes = Array(60).fill(1).map((x,i)=>i);
    this.hours = Array(24).fill(1).map((x,i)=>i);
      this._fuseTranslationLoaderService.loadTranslations( en, vn);
  }

  ngOnInit(): void {
    var value = (this.el.nativeElement.value)
    if(value) {
      var time = value.split(':');
      this.hour = +time[0];
      this.minute = +time[1];
      setTimeout(()=>{
        this.divHours.nativeElement.scrollTop = this.hour * 54
        this.divMinutes.nativeElement.scrollTop = this.minute * 54
      }, 30)
    }
    this.el.nativeElement.closest('mat-form-field').classList.add('mat-focused')
  }

  emitInputEvent(){
    if(this.hour != undefined && this.minute !=undefined) {
      this.el.nativeElement.value = this.hour.toString().padStart(2, '0') + ':' + this.minute.toString().padStart(2, '0')
      var event = new Event('input', {
          bubbles: true,
          cancelable: true,
      });
      
      this.el.nativeElement.dispatchEvent(event);
    }
  }

  ngOnDestroy(): void {
    var event = new Event('blur', {
      bubbles: true,
      cancelable: true,
    });
    this.el.nativeElement.closest('mat-form-field').classList.remove('mat-focused')
    this.el.nativeElement.dispatchEvent(event);
  }

  setHour(hour) {
    this.hour = hour
    this.divHours.nativeElement.scrollTo({top: this.hour * 54, behavior: 'smooth'});
    this.emitInputEvent();
  }

  setMinute(minute) {
    this.minute = minute
    this.divMinutes.nativeElement.scrollTo({top: this.minute * 54, behavior: 'smooth'});
    this.emitInputEvent();
  }

  setNow(){
    const d = new Date();
    this.hour = d.getHours()
    this.minute = d.getMinutes()
    this.divHours.nativeElement.scrollTop = this.hour * 54
    this.divMinutes.nativeElement.scrollTop = this.minute * 54
    this.emitInputEvent();
  }
}
